import React, { useState } from 'react';
import NegotiationForm from '../components/NegotiationForm';
import EnquiryForm from '../components/EnquiryForm';
import SupportForm from '../components/SupportForm';
import ReceptionistForm from '../components/ReceptionistForm';
import SalesForm from '../components/SalesForm';
import enquiryImg from '../assets/enquiry.svg';
import supportImg from '../assets/support.svg';
import receptionistImg from '../assets/receptionist.svg';
import salesImg from '../assets/sales.svg';

export default function ConversationalAI() {
  const [mode, setMode] = useState(null); // 'enquiry' | 'support' | 'receptionist' | 'sales'
  const bots = [
    { key: 'enquiry', title: 'Send Enquiry Bot', img: enquiryImg, desc: 'Inform sellers about new buyer enquiries with precise details and next steps.', bullets: ['Buyer note summary', 'Optional quantity/contacts', 'Short and friendly'] },
    { key: 'support', title: 'Customer Support Agent', img: supportImg, desc: 'Capture and triage issues like delivery, returns, billing, and account.', bullets: ['Issue categorization', 'Order ID + priority', 'Clear next steps'] },
    { key: 'receptionist', title: 'AI Receptionist', img: receptionistImg, desc: 'Greet callers, identify purpose, and route with callback details.', bullets: ['Purpose detection', 'Collect essentials', 'Schedule follow-up'] },
  ];

  return (
    <div className="page">
      <header className="header">
        <h1>Voice Agents</h1>
      </header>

      {!mode && (
        <>
          <section className="hero">
            <div className="hero-text">
              <h2>Real-Time Voice Agents for Maskan</h2>
              <p>Launch outbound calls that greet, qualify, negotiate, and support — all aligned to your brand.</p>
              <ul>
                <li>Seamless integration with your current workflows</li>
                <li>User‑friendly forms for quick call setup</li>
              </ul>
            </div>
            <div className="hero-art" aria-hidden>
              <div className="chart"></div>
            </div>
          </section>

          <main className="grid-three">
            {bots.map(b => (
              <div className="bot-card" key={b.key} onClick={() => setMode(b.key)}>
                <div className="card-media"><img src={b.img} alt="" /></div>
                <div className="card-body">
                  <h3>{b.title}</h3>
                  <p>{b.desc}</p>
                  <ul>
                    {b.bullets.map((t, i) => (<li key={i}>{t}</li>))}
                  </ul>
                  <button className="btn-cta btn-block">Configure &amp; Call =&gt;</button>
                </div>
              </div>
            ))}
          </main>

          <section className="feature-row">
            <div className="feature-card" onClick={() => setMode('sales')}>
              <div className="feature-body">
                <h3>Sales Agent</h3>
                <p>Qualify leads, gather requirements, and move decisively toward quotes or demos — all aligned to Maskan’s sales playbook.</p>
                <ul>
                  <li>Lead qualification (quantity, specs, region, timeline)</li>
                  <li>Negotiates within price bands, MOQs, and volume discounts</li>
                  <li>Clear next steps: quote, demo, or scheduled follow‑up</li>
                </ul>
                <button className="btn-cta">Configure &amp; Call =&gt;</button>
              </div>
              <div className="feature-media">
                <div className="popup">
                  <h4>Negotiation built‑in</h4>
                  <p>The Sales Agent can negotiate confidently within your price bands and order ranges, offering volume‑based discounts and tiered proposals that help you close faster.</p>
                  <ul>
                    <li>Price bands + MOQs respected</li>
                    <li>Volume discount logic explained clearly</li>
                    <li>Concise summary + next steps</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {mode === 'enquiry' && (
        <main className="container">
          <div className="panel">
            <button className="back-btn" onClick={() => setMode(null)}>&larr; Back</button>
            <h2>Send Enquiry Bot</h2>
            <EnquiryForm />
          </div>
        </main>
      )}

      {mode === 'support' && (
        <main className="container">
          <div className="panel">
            <button className="back-btn" onClick={() => setMode(null)}>&larr; Back</button>
            <h2>Customer Support Agent</h2>
            <SupportForm />
          </div>
        </main>
      )}

      {mode === 'receptionist' && (
        <main className="container">
          <div className="panel">
            <button className="back-btn" onClick={() => setMode(null)}>&larr; Back</button>
            <h2>AI Receptionist</h2>
            <ReceptionistForm />
          </div>
        </main>
      )}

      {mode === 'sales' && (
        <main className="container">
          <div className="panel">
            <button className="back-btn" onClick={() => setMode(null)}>&larr; Back</button>
            <h2>Sales Agent</h2>
            <SalesForm />
          </div>
        </main>
      )}
    </div>
  );
}

